import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            观众口碑
          </h2>
          <p className="text-sm text-foreground-500 mt-1">真实用户 · 真心评价</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-5xl mx-auto">
          {commentsData.map((comment, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200 p-5 md:p-6"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-background-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                "{comment.content}"
              </p>
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-foreground-900">{comment.author}</span>
                <span className="text-xs text-foreground-400">{comment.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}